import React, { Component } from 'react';
import axios from '../../axios';
import apiError from '../../error';
import { ProgressBar } from 'react-bootstrap';
export default class AiVishingMinuteConsumption extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: null,
            callDurationExhausted: 0,
            callDurationLimit: 0
        };
    }

    componentDidMount = () => {
        this.loadData();
    }

    loadData = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.get('/api/ai-vishing/minute-consumption');
            this.setState({ callDurationExhausted: res.data.callDurationExhausted, callDurationLimit: res.data.callDurationLimit, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }

    render() {

        return (
            <div className='ai-vishing-minute-consumption'>
                <div className='minute-consumption-header'>
                    <h3>AI Vishing Subscription</h3>
                    <p>Allocated minutes available for AI-Vishing simulation. Transcript recording will stop once the allotted minutes are fully consumed.</p>
                </div>
                <div className='ai-vishing-minute-consumption-content'>
                    <div className='content-minutes-consumed'>
                        <p className='minutes-consumed-label'>Minutes Consumed</p>
                        <p className='minutes-consumed-value'>{this.state.callDurationExhausted}/{this.state.callDurationLimit}</p>
                    </div>
                    <ProgressBar now={(this.state.callDurationExhausted / this.state.callDurationLimit) * 100} visuallyHidden />
                    <p className='minute-consumption-content-remaining'>Remaining: <span>{this.state.callDurationLimit - this.state.callDurationExhausted} mins</span></p>
                </div>
            </div>
        );
    }
}